const config = {
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:3000",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000",
  WAYABANK_URL: process.env.REACT_APP_WAYABANK_URL || "http://localhost:3000",
  WEBSITE_URL: "https://app.staging.wayapay.ng",
};

export default config;
